export const preferenceMap = {
  ESCAPE: "密室逃脫",
  REALITY: "實境解謎",
  SCENARIO: "劇本殺"
};

export const preferenceKeyList = Object.keys(preferenceMap);